<template>
  <div v-if="gamesStats">
    <b-progress size="is-large" :max="gamesStats.total">
      <template #bar>
        <!-- BOTS -->
        <b-progress-bar
          :value="gamesStats.bots"
          type="is-dark"
          :show-value="!!gamesStats.bots"
        >
          {{ gamesStats.bots }}
        </b-progress-bar>

        <!-- BYE -->
        <b-progress-bar
          :value="gamesStats.bye"
          type="is-primary"
          :show-value="!!gamesStats.bye"
        >
          {{ gamesStats.bye }}
        </b-progress-bar>

        <!-- FINISHED  -->
        <b-progress-bar
          :value="gamesStats.finished"
          type="is-info"
          :show-value="!!gamesStats.finished"
        >
          {{ gamesStats.finished }}
        </b-progress-bar>

        <!-- LIVE -->
        <b-progress-bar
          :value="gamesStats.unfinished"
          type="is-success"
          :show-value="!!gamesStats.unfinished"
        >
          {{ gamesStats.unfinished }}
        </b-progress-bar>
      </template>
    </b-progress>
  </div>
</template>

<script>
export default {
  name: "GamesProgressBar",

  props: ["gamesStats"],
};
</script>

<style scoped></style>
